import { GroupField } from "../../../../app/user/profile/profileUtils";

export const generateTrackingInfo = (question: GroupField | undefined) => {
  if(!question){
    return
  }
   return {
    track: `profile-completion-${question?.field}`,
    trackAbacus: `profile-completion-${question?.field}`,
    trackText: "current profile completion question"
  };
}